import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { ENDPOINT_PUBLIC_MODULES } from './constants';

export function useModulePublicService() {
  const { backendGet } = Sebrae.useBackend();

  const dataPublicModule = React.useCallback(
    (id) => backendGet(`${ENDPOINT_PUBLIC_MODULES}/${id}`),
    [backendGet],
  );

  return {
    dataPublicModule,
  };
}
